import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => (
  <div className="bg-black text-white pt-24">
    <div className="bg-gradient-to-br from-black to-gray-900 py-16">
      <div className="container mx-auto px-6 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Terms of <span className="text-[#F4B400]">Service</span></h1>
        <p className="text-gray-400">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
      </div>
    </div>
    <div className="bg-white text-black py-16">
      <div className="container mx-auto px-6 max-w-4xl prose prose-lg">
        <h2 className="text-2xl font-bold mt-8 mb-4">1. Acceptance of Terms</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          By accessing and using ealagon.com ("the Website"), operated by Enrigo Studio, you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, you must not use our website.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">2. Description of Services</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          Enrigo Studio provides creative design services including but not limited to graphic design, web development, print design, digital marketing, audio & video production, and corporate consulting. Our website serves as a portfolio, blog, and e-commerce platform for our services and products.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">3. User Accounts</h2>
        <p className="text-gray-700 leading-relaxed mb-4">When creating an account, you agree to:</p>
        <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
          <li>Provide accurate and complete information</li>
          <li>Maintain the security of your account credentials</li>
          <li>Accept responsibility for all activities under your account</li>
          <li>Notify us immediately of any unauthorized use</li>
        </ul>

        <h2 className="text-2xl font-bold mt-8 mb-4">4. Intellectual Property</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          All content on this website, including text, graphics, logos, images, designs, and software, is the property of Enrigo Studio and is protected by intellectual property laws. You may not reproduce, distribute, or create derivative works without our express written permission.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">5. Products and Services</h2>
        <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
          <li>All prices are subject to change without notice</li>
          <li>We reserve the right to refuse or cancel any order</li>
          <li>Product images are for illustration purposes and may vary</li>
          <li>Custom design services are subject to individual agreements</li>
          <li>Delivery timelines are estimates and not guarantees</li>
        </ul>

        <h2 className="text-2xl font-bold mt-8 mb-4">6. User Conduct</h2>
        <p className="text-gray-700 leading-relaxed mb-4">You agree not to:</p>
        <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
          <li>Use the website for any unlawful purpose</li>
          <li>Attempt to gain unauthorized access to any part of the website</li>
          <li>Interfere with or disrupt the website's functionality</li>
          <li>Upload malicious code or content</li>
          <li>Impersonate any person or entity</li>
          <li>Scrape or collect data without authorization</li>
        </ul>

        <h2 className="text-2xl font-bold mt-8 mb-4">7. Blog and User Content</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          Content published on our blog is for informational purposes only. We reserve the right to remove any user-submitted content that violates these terms or is deemed inappropriate.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">8. Third-Party Links and Advertising</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          Our website may contain links to third-party websites and display advertisements through Google AdSense. We are not responsible for the content, privacy policies, or practices of third-party sites. The inclusion of advertisements does not imply endorsement.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">9. Disclaimer of Warranties</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          The website and services are provided "as is" without warranties of any kind, either express or implied. We do not guarantee that the website will be uninterrupted, error-free, or free of viruses or other harmful components.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">10. Limitation of Liability</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          To the fullest extent permitted by law, Enrigo Studio shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of your use of the website or services.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">11. Governing Law</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          These Terms shall be governed by and construed in accordance with the laws of the State of Connecticut, United States, without regard to its conflict of law provisions.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">12. Changes to Terms</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          We reserve the right to modify these Terms at any time. Continued use of the website after changes constitutes acceptance of the updated terms.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">13. Contact</h2>
        <p className="text-gray-700 leading-relaxed mb-4">For questions about these Terms, contact us:</p>
        <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
          <li>Email: <a href="mailto:enrigo@ealagon.com" className="text-[#F4B400] hover:underline">enrigo@ealagon.com</a></li>
          <li>Phone: <a href="tel:+18608470649" className="text-[#F4B400] hover:underline">(860) 847-0649</a></li>
          <li>Address: 30 Airport Rd, Hartford, CT 06114</li>
        </ul>
      </div>
    </div>
  </div>
);

export default TermsOfService;
